import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Partners from "@/components/site/Partners";
import ChiEthic from "@/components/site/ChiEthic";
import Manifesto from "@/components/site/Manifesto";
import Metodo from "@/components/site/Metodo";
import EnergyManager from "@/components/site/EnergyManager";
import Servizi from "@/components/site/Servizi";
import EsgSimulator from "@/components/site/EsgSimulator";
import Osservatorio from "@/components/site/Osservatorio";
import Target from "@/components/site/Target";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CtaPopup from "@/components/site/CtaPopup";
import { useLenis, scrollToSection } from "@/hooks/useLenis";

export default function Landing() {
  useLenis();
  const location = useLocation();

  // Navigazione con hash da altre pagine (es. /#contatti): attende che la sezione esista e poi scorre.
  // Senza hash: forza l'inizio pagina (niente ripristino posizione al refresh).
  useEffect(() => {
    if (!location.hash) {
      window.__lenis?.scrollTo(0, { immediate: true, force: true });
      window.scrollTo(0, 0);
      return;
    }
    let tries = 0;
    const timer = setInterval(() => {
      if (document.querySelector(location.hash)) {
        setTimeout(() => scrollToSection(location.hash), 100);
        clearInterval(timer);
      } else if (++tries > 25) {
        clearInterval(timer);
      }
    }, 200);
    return () => clearInterval(timer);
  }, [location.hash]);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <ChiEthic />
        <Servizi />
        <Target />
        <Metodo />
        <EnergyManager />
        <Manifesto />
        <EsgSimulator />
        <Osservatorio />
        <Contact />
        <Partners />
      </main>
      <Footer />
      <CtaPopup />
    </>
  );
}
